import { Component, OnInit, Input } from '@angular/core';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-widget-services',
    templateUrl: './widget-services.component.html',
    styleUrls: ['./widget-services.component.scss'],
})
export class WidgetServicesComponent implements OnInit {
    @Input() widgetTitle: any;
    @Input() useThumb = false;
    @Input() widgetID: any;
    @Input() regionId: any;

    services = [];
    widgetStyle:any;
    background:any ;

    constructor(private widgetsService: WidgetsService,private domSanitizer:DomSanitizer) { }

    async ngOnInit() {
        console.log("this is a widget title",this.widgetTitle)

        let widgetData: any = await this.widgetsService.getWidgetData(this.widgetID);
        if (widgetData && widgetData.style && Object.keys(widgetData.style).length != 0) {
            this.widgetStyle = widgetData.style;
            if(this.widgetStyle.backgroundImage){
                this.background = this.domSanitizer.bypassSecurityTrustStyle(`url(${this.widgetStyle.backgroundImage})`);
            }
            else if(this.widgetStyle.backgroundColor){
                this.background = this.widgetStyle.backgroundColor;
            }
            else{
                //this.background = 'transparent';
            }
        }

        if (widgetData && widgetData.serviceList && widgetData.serviceList.length) {
            widgetData.serviceList.forEach(async id => {
                const service: any = await this.widgetsService.getCBSDataFromId(id, 'services');
                if (service) {
                    if (this.regionId) {
                        if (service.regionId && service.regionId.length && service.regionId.includes(this.regionId)) {
                            this.services.push({ id, ...service });
                        }
                    } else {
                        this.services.push({ id, ...service });
                    }
                }
            });
        }
    }

}
